import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalBar } from 'react-chartjs-2';

export default class HorizontalBarChart extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    options: PropTypes.object,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  static defaultProps = {
    data: [],
  };

  render() {
    return (
      <HorizontalBar
        data={{
          labels: this.props.labels,
          datasets: [
            {
              data: this.props.data,
              backgroundColor: this.props.colors,
            },
          ],
        }}
        options={{
          maintainAspectRatio: false,
          ...this.props.options,
        }}
      />
    );
  }
}
